import React from "react";
export function useHeight() {
    const resizeObserver = React.useRef(null);
    const [height, setHeight] = React.useState(0);
    const eleRef = React.useRef(null);
    React.useLayoutEffect(() => {
        const handleFooterSize = (entries) => {
            const footerHeight = entries[0].borderBoxSize[0].blockSize;
            setHeight(footerHeight);
        };
        if (eleRef.current) {
            resizeObserver.current = new ResizeObserver(handleFooterSize);
            resizeObserver.current.observe(eleRef.current, { box: "border-box" });
        }
        return () => {
            if (resizeObserver.current)
                resizeObserver.current.disconnect();
        };
    }, []);
    return [height, eleRef];
}
